import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { DestinationForm } from '@/modules/backups/DestinationForm';
import { dialogSurface } from '@/components/surface/tones';

/**
 * The add-storage form, in a dialog.
 *
 * The form is unmounted when the dialog closes, so every opening starts clean — the same as the
 * inline form it replaces, and the reason a half-typed secret key never lingers in memory.
 */
export function DestinationDialog({
  open,
  onOpenChange,
  onDone,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDone: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`max-w-xl ${dialogSurface}`}>
        <DialogHeader>
          <DialogTitle>Add backup storage</DialogTitle>
          <DialogDescription>Pushed to cloud storage you own, or kept on the server to download.</DialogDescription>
        </DialogHeader>
        <DestinationForm onDone={onDone} onCancel={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}
